import { gql } from "graphql-request";

export const ADMIN_RESTORE_FILE_HISTORY = gql`
  mutation AdminRestoreFileHistory($historyId: ID!) {
    adminRestoreFileHistory(historyId: $historyId) {
      _id
      title
      updatedAt
    }
  }
`;
